import { render, staticRenderFns } from "./AssignCoupons.vue?vue&type=template&id=151b9efc&"
import script from "./AssignCoupons.vue?vue&type=script&lang=js&"
export * from "./AssignCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports